import { createGlobalStyle } from 'styled-components'

import { FONT_FAMILY_ALT } from '../theme'

const GlobalStyle = createGlobalStyle`
  html {
    background-color: black;
    color: white;
  }

  body {
    font-size: 14px;
    line-height: 1.5;
    font-family: ${FONT_FAMILY_ALT};
    font-kerning: normal;
    text-rendering: optimizeLegibility;
    font-weight: 800;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss01' on, 'cv01' on, 'cv03' on;
    text-transform: uppercase;

    font-variant: none;
  }
`

export default GlobalStyle
